const copy = {
  preChat: {
    headerText: "How can I help?",
    secondaryHeaderText: (displayName: string) => `Ask our ${displayName}!`,
    subText: "Need help getting started?",
    anchorText: "View quick start guide",
  },
};

export default copy;
